var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrophy = function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 67,
    width: 86,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.78 53.153c15.073 14.509 24.437 8.51 48.112-5.238 21.7-10.464 19.682-43.62 1.434-44.551-19.862-1.015-12.276 7.719-30.47 9.87C-9.619 18.495 2.543 40.41 15.78 53.154z",
    fill: "#0f1419"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 15,
    fill: "gold",
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 10,
    fill: "#fff",
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 45,
    fill: "#87ceeb",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 35,
    fill: "gold",
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 30,
    fill: "#fff",
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 55,
    fill: "#87ceeb",
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.015 24.673a6.072 6.072 0 0 0 6.064 6.064 2.695 2.695 0 0 0 2.692-2.691V14.803a2.695 2.695 0 0 0-2.692-2.691h-3.373a2.695 2.695 0 0 0-2.691 2.691zm2.834 0v-9.727h3.087V27.9a3.234 3.234 0 0 1-3.087-3.227zM53.244 28.046a2.695 2.695 0 0 0 2.692 2.691 6.072 6.072 0 0 0 6.065-6.064v-9.87a2.695 2.695 0 0 0-2.692-2.691h-3.373a2.695 2.695 0 0 0-2.692 2.691zm2.835-.146V14.946h3.086v9.727A3.234 3.234 0 0 1 56.08 27.9z",
    fill: "#e74c3c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 31,
    fill: "#f39c12",
    rx: 1.5,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56,
    cy: 31,
    fill: "#f39c12",
    rx: 1.5,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 33,
    fill: "#ff6b35",
    rx: 1,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56,
    cy: 33,
    fill: "#ff6b35",
    rx: 1,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.558 50.143H37.532l3.499-21.133H46z",
    fill: "#34495e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 32h2v1.5h-2z",
    fill: "#3498db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 35h2v1.5h-2z",
    fill: "#e74c3c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 40,
    fill: "#2ecc71",
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.97 49.075h16.15c.433 0 .785.351.785.784v1.12a.785.785 0 0 1-.785.784H34.97a.785.785 0 0 1-.784-.784v-1.12c0-.433.351-.784.785-.784z",
    fill: "#95a5a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.413 51.316h23.265c.277 0 .502.225.502.502v6.084a.502.502 0 0 1-.502.502H31.413a.502.502 0 0 1-.502-.502v-6.084c0-.277.224-.502.502-.502z",
    fill: "#7f8c8d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 54.5,
    fill: "#e74c3c",
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 54.5,
    fill: "#2ecc71",
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 54.5,
    fill: "#f39c12",
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 54.5,
    fill: "#3498db",
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 54.5,
    fill: "#e74c3c",
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.045 39.77c-7.113 0-12.933-5.82-12.933-12.933V8.989H55.98v17.848c0 7.113-5.82 12.933-12.934 12.933z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#16213e"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 20,
    opacity: 0.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 20,
    opacity: 0.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 28,
    opacity: 0.8,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#87ceeb"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 19.5,
    opacity: 0.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 19.5,
    opacity: 0.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 27.5,
    opacity: 0.6,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.166 5.631h27.758c.76 0 1.376.616 1.376 1.376v2.049c0 .76-.616 1.376-1.376 1.376H29.166c-.76 0-1.376-.616-1.376-1.376V7.007c0-.76.616-1.376 1.376-1.376z",
    fill: "#3498db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 3h1v3h-1z",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 2.5,
    fill: "#e74c3c",
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.993 52.504h18.105v4.816H33.993z",
    fill: "#95a5a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.965 26.824h2.827l1.547-7.642h-2.563l.442-2.209c1.634-.265 2.65-.663 3.754-1.325h2.607l-2.253 11.176H47.8l-.574 2.827H38.39z",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 8 2-2 2 2-2 2z",
    fill: "gold",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65 40 2-2 2 2-2 2z",
    fill: "#87ceeb",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 25,
    fill: "#8b5a2b",
    opacity: 0.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 45,
    fill: "#4a90e2",
    opacity: 0.6,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 10,
    fill: "#fff",
    opacity: 0.4,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 5,
    fill: "gold",
    opacity: 0.5,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 8,
    fill: "#87ceeb",
    opacity: 0.6,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 25,
    fill: "#fff",
    opacity: 0.4,
    r: 0.4
  }))));
};
export default SvgTrophy;